import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "stack",
  "use": "stack-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"stack\"><path d=\"M512 160L256 32 0 160l256 128 256-128zM256 74.485L427.029 160 256 245.515 84.971 160 256 74.485zm204.722 155.876L512 256 256 384 0 256l51.278-25.639L256 332.722zm0 96L512 352 256 480 0 352l51.278-25.639L256 428.722z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/stack.svg
// module id = v9vg
// module chunks = 1